/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AvailableForAllocationReinsuredOptionDto } from './AvailableForAllocationReinsuredOptionDto';
import {
    AvailableForAllocationReinsuredOptionDtoFromJSON,
    AvailableForAllocationReinsuredOptionDtoFromJSONTyped,
    AvailableForAllocationReinsuredOptionDtoToJSON,
    AvailableForAllocationReinsuredOptionDtoToJSONTyped,
} from './AvailableForAllocationReinsuredOptionDto';
import type { AvailableForAllocationOriginalCurrencyOptionDto } from './AvailableForAllocationOriginalCurrencyOptionDto';
import {
    AvailableForAllocationOriginalCurrencyOptionDtoFromJSON,
    AvailableForAllocationOriginalCurrencyOptionDtoFromJSONTyped,
    AvailableForAllocationOriginalCurrencyOptionDtoToJSON,
    AvailableForAllocationOriginalCurrencyOptionDtoToJSONTyped,
} from './AvailableForAllocationOriginalCurrencyOptionDto';
import type { AvailableForAllocationBinderOptionDto } from './AvailableForAllocationBinderOptionDto';
import {
    AvailableForAllocationBinderOptionDtoFromJSON,
    AvailableForAllocationBinderOptionDtoFromJSONTyped,
    AvailableForAllocationBinderOptionDtoToJSON,
    AvailableForAllocationBinderOptionDtoToJSONTyped,
} from './AvailableForAllocationBinderOptionDto';
import type { AvailableForAllocationInsuredOptionDto } from './AvailableForAllocationInsuredOptionDto';
import {
    AvailableForAllocationInsuredOptionDtoFromJSON,
    AvailableForAllocationInsuredOptionDtoFromJSONTyped,
    AvailableForAllocationInsuredOptionDtoToJSON,
    AvailableForAllocationInsuredOptionDtoToJSONTyped,
} from './AvailableForAllocationInsuredOptionDto';

/**
 * 
 * @export
 * @interface AvailableForAllocationOptionsResponseDto
 */
export interface AvailableForAllocationOptionsResponseDto {
    /**
     * 
     * @type {Array<AvailableForAllocationInsuredOptionDto>}
     * @memberof AvailableForAllocationOptionsResponseDto
     */
    insured: Array<AvailableForAllocationInsuredOptionDto>;
    /**
     * 
     * @type {Array<AvailableForAllocationReinsuredOptionDto>}
     * @memberof AvailableForAllocationOptionsResponseDto
     */
    reinsured: Array<AvailableForAllocationReinsuredOptionDto>;
    /**
     * 
     * @type {Array<AvailableForAllocationBinderOptionDto>}
     * @memberof AvailableForAllocationOptionsResponseDto
     */
    binders: Array<AvailableForAllocationBinderOptionDto>;
    /**
     * 
     * @type {Array<AvailableForAllocationOriginalCurrencyOptionDto>}
     * @memberof AvailableForAllocationOptionsResponseDto
     */
    originalCurrencies: Array<AvailableForAllocationOriginalCurrencyOptionDto>;
}

/**
 * Check if a given object implements the AvailableForAllocationOptionsResponseDto interface.
 */
export function instanceOfAvailableForAllocationOptionsResponseDto(value: object): value is AvailableForAllocationOptionsResponseDto {
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('reinsured' in value) || value['reinsured'] === undefined) return false;
    if (!('binders' in value) || value['binders'] === undefined) return false;
    if (!('originalCurrencies' in value) || value['originalCurrencies'] === undefined) return false;
    return true;
}

export function AvailableForAllocationOptionsResponseDtoFromJSON(json: any): AvailableForAllocationOptionsResponseDto {
    return AvailableForAllocationOptionsResponseDtoFromJSONTyped(json, false);
}

export function AvailableForAllocationOptionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableForAllocationOptionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insured': ((json['insured'] as Array<any>).map(AvailableForAllocationInsuredOptionDtoFromJSON)),
        'reinsured': ((json['reinsured'] as Array<any>).map(AvailableForAllocationReinsuredOptionDtoFromJSON)),
        'binders': ((json['binders'] as Array<any>).map(AvailableForAllocationBinderOptionDtoFromJSON)),
        'originalCurrencies': ((json['originalCurrencies'] as Array<any>).map(AvailableForAllocationOriginalCurrencyOptionDtoFromJSON)),
    };
}

export function AvailableForAllocationOptionsResponseDtoToJSON(json: any): AvailableForAllocationOptionsResponseDto {
    return AvailableForAllocationOptionsResponseDtoToJSONTyped(json, false);
}

export function AvailableForAllocationOptionsResponseDtoToJSONTyped(value?: AvailableForAllocationOptionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insured': ((value['insured'] as Array<any>).map(AvailableForAllocationInsuredOptionDtoToJSON)),
        'reinsured': ((value['reinsured'] as Array<any>).map(AvailableForAllocationReinsuredOptionDtoToJSON)),
        'binders': ((value['binders'] as Array<any>).map(AvailableForAllocationBinderOptionDtoToJSON)),
        'originalCurrencies': ((value['originalCurrencies'] as Array<any>).map(AvailableForAllocationOriginalCurrencyOptionDtoToJSON)),
    };
}

